import moment from "moment";
import React, { useState, useEffect, useMemo } from "react";
import { DOMAINREGEX } from "../../App.config";
import { useDispatch, useSelector } from "react-redux";
import * as utilities from "../../utilities/utils";
import Moment from 'moment';
import { useForm, useFieldArray, Controller, useWatch } from "react-hook-form";
import ReactDOM from "react-dom";


const CompanyServices = (props) => {
  const [customeError, setCustomeError] = useState({});
  const { register, control, handleSubmit, reset, watch, setValue, getValues, formState: { errors } } = useForm();

  const userAuthReducer = useSelector((state) => state.userAuthReducer);

  const onChange = (indexForField, e) => {
    setCustomeError({});
  }

  const handleSubmitData = (data) => {
    props.saveCompanyServiceSetting(data, props.selectedCompany);
  }

  return (
    <>
      {console.log(userAuthReducer.companyServices?.hasLevelFileFeature)}
      {userAuthReducer.companyServices ? <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header">
            Company Services
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
              onClick={() => props.closeRemoveModal()}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div className="modal-body">
            <span>
              <ul>
                <li className="">
                  <div className="list-group">
                    <>
                      <form onSubmit={handleSubmit(handleSubmitData)}>
                        <input type="hidden" name=""
                          {...register("companyId", { value: props.selectedCompany })} />
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="levelFileUpload"
                                name="levelFileUpload"
                                {...register("hasLevelFileFeature", { value: userAuthReducer.companyServices?.hasLevelFileFeature })}
                              />
                              <label htmlFor="levelFileUpload">
                                <span>
                                  Level File Upload
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="empFileUpload"
                                name="empFileUpload"
                                {...register("hasDemographicFileFeature", { value: userAuthReducer.companyServices?.hasDemographicFileFeature })}
                              />
                              <label htmlFor="empFileUpload">
                                <span>
                                  Demographic File Upload
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="stdForm"
                                name="stdForm"
                                {...register("hasSTDFormFeature", { value: userAuthReducer.companyServices?.hasSTDFormFeature })}
                              />
                              <label htmlFor="stdForm">
                                <span>
                                  {props.context.t("STD-Hamburger.text")}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="airForm"
                                name="airForm"
                                {...register("hasAIRFormFeature", { value: userAuthReducer.companyServices?.hasAIRFormFeature })}
                              />
                              <label htmlFor="airForm">
                                <span>
                                  {props.context.t("STD-Dashboard.label.Sidebar.heading.title-6")}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="acmdForm"
                                name="acmdForm"
                                {...register("hasACMDFormFeature", { value: userAuthReducer.companyServices?.hasACMDFormFeature })}
                              />
                              <label htmlFor="acmdForm">
                                <span>
                                  {props.context.t("STD-Dashboard.label.Sidebar.heading.title-7")}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="ccmForm"
                                name="ccmForm"
                                {...register("hasCCMFormFeature", { value: userAuthReducer.companyServices?.hasCCMFormFeature })}
                              />
                              <label htmlFor="ccmForm">
                                <span>
                                  {props.context.t("CCM.Page.ShortTitle")}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="absenceTracking"
                                name="absenceTracking"
                                {...register("hasAbsenceTrackingFeature", { value: userAuthReducer.companyServices?.hasAbsenceTrackingFeature })}
                              />
                              <label htmlFor="absenceTracking">
                                <span>
                                  {props.context.t("STD-Dashboard.label.Sidebar.heading.title-3")}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="assessmentFeature"
                                name="assessmentFeature"
                                {...register("hasAssessmentFeature", { value: userAuthReducer.companyServices?.hasAssessmentFeature })}
                              />
                              <label htmlFor="assessmentFeature">
                                <span>
                                  {props.context.t("STD-Dashboard.label.Sidebar.heading.title-8")}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="form-group">
                          <div className="Check-box">
                            <div>
                              <input
                                className="styled-checkbox"
                                type="checkbox"
                                id="ltdFeature"
                                name="ltdFeature"
                                {...register("hasLtdFeature", { value: userAuthReducer.companyServices?.hasLtdFeature })}
                              />
                              <label htmlFor="ltdFeature">
                                <span>
                                  {props.context.t("STD-Dashboard.label.Sidebar.heading.title-5")}
                                </span>
                              </label>
                            </div>
                          </div>
                        </div>
                        <input type="submit" className="btn btn-primary float-right" />
                      </form>
                    </>
                  </div>
                </li>
              </ul>
            </span>
          </div>
        </div >
      </div> : null}
    </>
  );
};
export default CompanyServices;
